const About = function() {
    return (
        <section>
            <h1>About</h1>
            <h2>What is MusicNotes?</h2>
            <p>MusicNotes is a simple, open-source tool that allows users to quickly create notes that detail elements of a song during deep listening or analysis. </p>
            <p><strong>Note:</strong> MusicNotes does not store any data on the server. Data is soley stored in the browser and will be lost upon browser data clears.</p>
            <h2>Why MusicNotes?</h2>
            <p>Taking notes about how a song progresses, changes, or experiments sonically can be helpful when stuck writing a piece of music or in need of inspiration. Taking notes during listening sessions can also facilitate honing critical listening skills.</p>
            <h2>Have Feature Suggestions?</h2>
            <p>I would love to hear your thoughts about MusicNotes. Whether its a bug, feature request, or any other feedback, I will do my best to respond.</p>
            <p>GitHub Repository: <a href="https://github.com/WilliamBirdsall/musicnotes">https://github.com/WilliamBirdsall/musicnotes</a></p>
        </section>
    );
};

export default About;
